// extracted by mini-css-extract-plugin
module.exports = {"customerList":"CustomerList_customerList__HOlWd","customers":"CustomerList_customers__qlmh0","loading":"CustomerList_loading__2Q4hQ"};